<template>
    <AppLayoutBase>
        <template slot="drawer">
            <AppLayoutNavbarDrawer title="Mitarbeiter-Gespräche">
                <template slot="img">
                    <img src="@/assets/employee-interview-primary.svg" alt="Mitarbeiter-Gespräche"/>
                </template>
                <template slot="list">
                    <EmployeeInterviewsLayoutDrawer/>
                </template>
            </AppLayoutNavbarDrawer>
        </template>

        <template slot="main">
            <EmployeeInterviewsCreateContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        props: ['id'],
        name: "EmployeeInterviewsCreate"
    }
</script>

<style scoped>

</style>